import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

const Tag = () => {
  const { tag } = useParams()
  const target = tag
    ? `/?tag=${encodeURIComponent(tag)}`
    : '/'

  return <Navigate to={target} replace />
}

export default Tag
